<p *ngIf="checking$ | async; else checking">redirecting...</p>
<ng-template #checking> <p>checking...</p> </ng-template>
